'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PassRecoveryStepThree = exports.PassRecoveryStepTwo = exports.PassRecoveryStepOne = exports.PassRecovery = undefined;

var _PassRecoveryStepOne = require('./PassRecoveryStepOne');

Object.defineProperty(exports, 'PassRecoveryStepOne', {
  enumerable: true,
  get: function get() {
    return _PassRecoveryStepOne.PassRecoveryStepOne;
  }
});

var _PassRecoveryStepTwo = require('./PassRecoveryStepTwo');

Object.defineProperty(exports, 'PassRecoveryStepTwo', {
  enumerable: true,
  get: function get() {
    return _PassRecoveryStepTwo.PassRecoveryStepTwo;
  }
});

var _PassRecoveryStepThree = require('./PassRecoveryStepThree');

Object.defineProperty(exports, 'PassRecoveryStepThree', {
  enumerable: true,
  get: function get() {
    return _PassRecoveryStepThree.PassRecoveryStepThree;
  }
});

var _PassRecovery2 = require('./PassRecovery');

var _PassRecovery3 = _interopRequireDefault(_PassRecovery2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.PassRecovery = _PassRecovery3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/PassRecovery/index.js
// module id = 753
// module chunks = 0